import { createApp } from 'vue'
import StreamDonationOverview from './StreamDonationOverview'

const el = '.kb-component--stream-donation-overview'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((StreamDonationOverviewDOM) => {
            const variation = StreamDonationOverviewDOM.dataset.variation || 'dark'
            const donationPosition = StreamDonationOverviewDOM.dataset.donationPosition || 'above'
            const fundraisingId = StreamDonationOverviewDOM.dataset.fundraisingId || ''
            const footerText = StreamDonationOverviewDOM.dataset.footerText || ''
            const minNyDonationSek = parseInt(StreamDonationOverviewDOM.dataset.minNyDonationSek, 10) || 2
            const maxNyDonationSek = parseInt(StreamDonationOverviewDOM.dataset.maxNyDonationSek, 10) || 10
            const donationStyle = StreamDonationOverviewDOM.dataset.donationStyle || 'normal'
            const component = createApp(StreamDonationOverview, { variation, donationPosition, fundraisingId, footerText, minNyDonationSek, maxNyDonationSek, donationStyle }).use(Store)
            component.mount(StreamDonationOverviewDOM)
        })
    }
}
